import { TranslationsContext } from '@telia-common-components/shared';
import * as React from 'react';
import { Separator, Notice, Grid, GridColumn, Button } from 'telia-front-react';
import { SALESCHANNEL_ARGOS } from '../InternetCalculatorInterfaces';
import { shouldShowArgosOrderNotice } from '../util/InternetOfferUtil';
import { useInternetCalculator } from '../InternetCalculatorProvider';
export const InternetArgosOrderNotice = (props) => {
    var _a;
    const translate = React.useContext(TranslationsContext).translate;
    const { internetOfferCards, offerFetchStatus, isDealer } = props;
    const { isSecureNet } = useInternetCalculator();
    if (!shouldShowArgosOrderNotice(internetOfferCards, isDealer, offerFetchStatus)) {
        return null;
    }
    const argosUrl = (_a = internetOfferCards.find((offer) => SALESCHANNEL_ARGOS === offer.salesChannel)) === null || _a === void 0 ? void 0 : _a.orderingUrl;
    const labelPrefix = isSecureNet ? 'secureNetCalculator' : 'internetCalculator';
    return (React.createElement(React.Fragment, null,
        React.createElement(Separator, { spacing: "small", color: "invisible" }),
        React.createElement(Notice, { type: "employee", align: "center" },
            React.createElement(Grid, { align: ['middle-xs'], noWrap: ['sm'] },
                React.createElement(GridColumn, { width: ['max-sm'] }, translate(`${labelPrefix}.argosOrderNotice.text`)),
                React.createElement(GridColumn, { width: ['min-sm'] },
                    React.createElement(Button, { text: translate(`${labelPrefix}.argosOrderNotice.ctaLabel`), iconRight: "#arrow-right", type: "employee", url: argosUrl })))),
        React.createElement(Separator, { spacing: "small", color: "invisible" })));
};
